export default function PremiumSuccess() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#0F0A24] text-white">
      <h1 className="text-4xl text-green-400 font-bold mb-4">
        Payment Successful 🎉
      </h1>
      <p className="text-gray-300 text-lg">
        You now have Premium access! Enjoy your personalized insights.
      </p>
    </div>
  );
}
